import AdminComponent from "../components/AdminComponent";

function AdminPage() {
    return (
        <AdminComponent />
    );
}


export default AdminPage;